import { render } from "./programs.vue?vue&type=template&id=5973cd73&scoped=true"
import script from "./programs.vue?vue&type=script&lang=js"
export * from "./programs.vue?vue&type=script&lang=js"

import "./programs.vue?vue&type=style&index=0&id=5973cd73&scoped=true&lang=scss"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5973cd73"]])

export default __exports__